import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const deleteUserPage = async (userId: number) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.delete(`/users/${userId}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as any;
};
